/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Post, UpdatePostRequest, UpdatePostState } from "store/modules/posts/types";

const initialState: UpdatePostState = {
    isRequesting: false,
    errors: []
};

const updatePostSlice = createSlice({
    name: "posts@updatePost",
    initialState,
    reducers: {
        updatePostRequest: (
            state,
            action: PayloadAction<UpdatePostRequest>
        ): void => {
            state.isRequesting = true;
            state.errors = [];
        },
        updatePostSuccess: (
            state,
            action: PayloadAction<Post | undefined>
        ): void => {
            state.isRequesting = false;            
        },
        updatePostFailed: (
            state,
            action: PayloadAction<string[]>
        ): void => {
            state.isRequesting = false;
            state.errors = action.payload;
        }
    }
});

export const {
    updatePostFailed,
    updatePostRequest,
    updatePostSuccess
} = updatePostSlice.actions;
export default updatePostSlice.reducer;
